<!-- pc mobile 通用 -->
<template>
  <div class="header">
    <div class="container">
      <NuxtLink>
        <img src="/images/logo.png" class="logo-img" />
      </NuxtLink>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.header {
  height: 71px;
  width: 100%;
  min-width: 1440px;
  position: absolute;
  top: 0;
  background-image: url('/images/headerBg.png');
  background-size: cover;
  z-index: 10;

  .container {
    width: 1440px;
    margin: 0 auto;

    .logo-img {
      width: 163px;
      margin-top: 20px;
    }
  }
}

@media screen and (orientation: portrait) {
  .header {
    height: 64rem;
    width: 100%;
    min-width: unset;

    .container {
      width: 100%;

      .logo-img {
        width: 130rem;
        margin: 14rem;
      }
    }
  }
}
</style>
